// Add your JS customizations here
jQuery(document).ready(function($) { 

	$('.dismiss_discount').click(function(event) {
		event.preventDefault();
		$('body').removeClass('discount_open'); 
		$.cookie('ls_close_discount', 'true', { expires: 2, path: '/', secure: true });
	});

	new WOW().init();
	$('body').addClass('active');

	if ($(window).scrollTop() > 50) {
		$('.navbar').addClass('scrolled');
	} else {
		$('.navbar').removeClass('scrolled');
	}

	$(window).on('scroll', function() {
		if ($(window).scrollTop() > 50) {
			$('.navbar').addClass('scrolled');
		} else {
			$('.navbar').removeClass('scrolled');
		}
	});

	$('.hamburger').click(function(event) {
		event.preventDefault();
		$(this).toggleClass('is-active');
		$('body').toggleClass('menu_open');
		$('#mobile_menu').toggleClass('open').scrollTop(0);
		$('#mobile_menu_top_level').removeClass('d-none');
		$('.second_level').removeClass('open');
		$('#mobile_menu').removeClass('bg-grey').removeClass('injectables_bg').removeClass('skin_bg').removeClass('body_suite_bg').removeClass('female_health_bg');
		$('.navbar').removeClass('bg-grey').removeClass('treatment_bg');
	});

	$('#mobile_menu_top_level .hasSub a').click(function(event) {
		event.preventDefault();
		var $menu = $(this).attr('href');
		if($menu == '#conditions_menu') {
			$('#mobile_menu').toggleClass('bg-grey');
			$('.navbar').toggleClass('bg-grey');
		}
		if($menu == '#injectables_menu') {
			$('#mobile_menu').toggleClass('injectables_bg');
			$('.navbar').toggleClass('treatment_bg');
		}
		if($menu == '#skin_menu') {
			$('#mobile_menu').toggleClass('skin_bg');
			$('.navbar').toggleClass('treatment_bg');
		}
		if($menu == '#body_suite_menu') {
			$('#mobile_menu').toggleClass('body_suite_bg');
			$('.navbar').toggleClass('treatment_bg');
		}
		if($menu == '#female_health') {
			$('#mobile_menu').toggleClass('female_health_bg');
			$('.navbar').toggleClass('treatment_bg');
		}
		var $target = $menu + '_mobile';
		$($target).toggleClass('open');
		$('#mobile_menu_top_level').toggleClass('d-none');
	});

	$('#primary_nav .hasSub a').click(function(event) {
		event.preventDefault();
		var $menu = $(this).attr('href');
		if($(this).hasClass('active')) {
			$(this).removeClass('active');
			$($menu).removeClass('active');
			$('.navbar').removeClass('desktop_menu_open');
			$('.navbar').removeClass('bg-grey');
			$('body').removeClass('no_scroll');
		} else {
			if($menu == '#conditions_menu') {
				$('.navbar').addClass('bg-grey');
			} else {
				$('.navbar').removeClass('bg-grey');
			}
			if($('.navbar').hasClass('desktop_menu_open')) {

			} else {
				$('.navbar').addClass('desktop_menu_open');
				$('body').addClass('no_scroll');	
			}
			$('#primary_nav .hasSub a').removeClass('active');
			$('.desktop_menu').removeClass('active');
			$(this).addClass('active');
			$($menu).addClass('active');
		}
	});

	$('#footer_menu_2 .hasSub a').click(function(event) {
		event.preventDefault();
		if ($(window).width() > 991) {
			var $menu = $(this).attr('href');
			if($(this).hasClass('active')) {
				$(this).removeClass('active');
				$($menu).removeClass('active');
				$('.navbar').removeClass('desktop_menu_open');
				$('.navbar').removeClass('bg-grey');
				$('body').removeClass('no_scroll');
			} else {
				if($menu == '#conditions_menu') {
					$('.navbar').addClass('bg-grey');
				} else {
					$('.navbar').removeClass('bg-grey');
				}
				if($('.navbar').hasClass('desktop_menu_open')) {

				} else {
					$('.navbar').addClass('desktop_menu_open');
					$('body').addClass('no_scroll');	
				}
				$('#primary_nav .hasSub a').removeClass('active');
				$('.desktop_menu').removeClass('active');
				$(this).addClass('active');
				$($menu).addClass('active');
			}
		} else {
			$('.hamburger').toggleClass('is-active');
			$('body').toggleClass('menu_open');
			$('#mobile_menu').toggleClass('open');
			var $menu = $(this).attr('href');
			if($menu == '#conditions_menu') {
				$('#mobile_menu').toggleClass('bg-grey');
				$('.navbar').toggleClass('bg-grey');
			}
			if($menu == '#injectables_menu') {
				$('#mobile_menu').toggleClass('injectables_bg');
				$('.navbar').toggleClass('treatment_bg');
			}
			if($menu == '#skin_menu') {
				$('#mobile_menu').toggleClass('skin_bg');
				$('.navbar').toggleClass('treatment_bg');
			}
			if($menu == '#body_suite_menu') {
				$('#mobile_menu').toggleClass('body_suite_bg');
				$('.navbar').toggleClass('treatment_bg');
			}
			if($menu == '#female_health_menu') {
				$('#mobile_menu').toggleClass('female_health_bg');
				$('.navbar').toggleClass('treatment_bg');
			}
			var $target = $menu + '_mobile';
			$($target).toggleClass('open');
			$('#mobile_menu_top_level').toggleClass('d-none');
		}
	});

	$('#footer_menu_1 .hasSub a').click(function(event) {
		event.preventDefault();
		if ($(window).width() > 991) {
			var $menu = $(this).attr('href');
			if($(this).hasClass('active')) {
				$(this).removeClass('active');
				$($menu).removeClass('active');
				$('.navbar').removeClass('desktop_menu_open');
				$('.navbar').removeClass('bg-grey');
				$('body').removeClass('no_scroll');
			} else {
				if($('.navbar').hasClass('desktop_menu_open')) {

				} else {
					$('.navbar').addClass('desktop_menu_open');
					$('body').addClass('no_scroll');
					$('.navbar').addClass('bg-grey');
				}
				$('#top_nav .hasSub a').removeClass('active');
				$('.desktop_menu').removeClass('active');
				$(this).addClass('active');
				$($menu).addClass('active');
			}
		} else {
			$('.hamburger').toggleClass('is-active');
			$('body').toggleClass('menu_open');
			$('#mobile_menu').toggleClass('open');
			var $menu = $(this).attr('href');
			if($menu == '#conditions_menu') {
				$('#mobile_menu').toggleClass('bg-grey');
				$('.navbar').toggleClass('bg-grey');
			}
			if($menu == '#injectables_menu') {
				$('#mobile_menu').toggleClass('injectables_bg');
				$('.navbar').toggleClass('treatment_bg');
			}
			if($menu == '#skin_menu') {
				$('#mobile_menu').toggleClass('skin_bg');
				$('.navbar').toggleClass('treatment_bg');
			}
			if($menu == '#body_suite_menu') {
				$('#mobile_menu').toggleClass('body_suite_bg');
				$('.navbar').toggleClass('treatment_bg');
			}
			if($menu == '#female_health_menu') {
				$('#mobile_menu').toggleClass('female_health_bg');
				$('.navbar').toggleClass('treatment_bg');
			}
			var $target = $menu + '_mobile';
			$($target).toggleClass('open');
			$('#mobile_menu_top_level').toggleClass('d-none');
		}
	});

	$('#top_nav .hasSub a').click(function(event) {
		event.preventDefault();
		var $menu = $(this).attr('href');
		if($(this).hasClass('active')) {
			$(this).removeClass('active');
			$($menu).removeClass('active');
			$('.navbar').removeClass('desktop_menu_open');
			$('.navbar').removeClass('bg-grey');
			$('body').removeClass('no_scroll');
		} else {
			if($('.navbar').hasClass('desktop_menu_open')) {

			} else {
				$('.navbar').addClass('desktop_menu_open');
				$('body').addClass('no_scroll');
				$('.navbar').addClass('bg-grey');
			}
			$('#top_nav .hasSub a').removeClass('active');
			$('.desktop_menu').removeClass('active');
			$(this).addClass('active');
			$($menu).addClass('active');
		}
	});

	$('.desktop_menu .close_menu').click(function(event) {
		event.preventDefault();
		var $menu = $(this).attr('href');
		$($menu).removeClass('active');
		$('.navbar').removeClass('bg-grey');
		$('#primary_nav .hasSub a').removeClass('active');
		$('.navbar').removeClass('desktop_menu_open');
		$('body').removeClass('no_scroll');
	});

	$('.close_sub').click(function(event) {
		event.preventDefault();
		var $target = $(this).attr('href');
		$($target).toggleClass('open');
		$('#mobile_menu_top_level').removeClass('d-none');
		$('#mobile_menu').removeClass('bg-grey').removeClass('injectables_bg').removeClass('skin_bg').removeClass('body_suite_bg').removeClass('female_health_bg');
		$('.navbar').removeClass('bg-grey').removeClass('treatment_bg');
	});

	$('.menu_launch').click(function(event) {
		event.preventDefault();
		if ($(window).width() > 991) {
			var $menu = $(this).attr('href');
			$('.navbar').addClass('desktop_menu_open');
			$('body').addClass('no_scroll');	
			$('#primary_nav .hasSub a[href="'+$menu+'"]').addClass('active');
			$($menu).addClass('active');
		} else {
			
			$('.hamburger').toggleClass('is-active');
			$('body').toggleClass('menu_open');
			$('#mobile_menu').toggleClass('open');
			$('#mobile_menu_top_level').addClass('d-none');
		

			var $menu = $(this).attr('href');
			if($menu == '#injectables_menu') {
				$('#mobile_menu').toggleClass('injectables_bg');
				$('.navbar').toggleClass('treatment_bg');
			}
			if($menu == '#skin_menu') {
				$('#mobile_menu').toggleClass('skin_bg');
				$('.navbar').toggleClass('treatment_bg');
			}
			if($menu == '#body_suite_menu') {
				$('#mobile_menu').toggleClass('body_suite_bg');
				$('.navbar').toggleClass('treatment_bg');
			}
			if($menu == '#female_health_menu') {
				$('#mobile_menu').toggleClass('female_health_bg');
				$('.navbar').toggleClass('treatment_bg');
			}
			var $target = $menu + '_mobile';
			$($target).toggleClass('open');
		}
	});

	$('#conditions_image_carousel').on('init', function(event, slick){
		$('#conditions_nav_container').matchHeight({
			target: $('#conditions_image_carousel'),
		});
	});

	$('#conditions_image_carousel').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		fade: true,
		dots: false,
		arrows: false,
		infinite: true,
		asNavFor: '#conditions_text_carousel, #conditions_nav_carousel',
	});

	$('#conditions_text_carousel').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		fade: true,
		arrows: true,
		dots: false,
		infinite: true,
		prevArrow: '.condition_prev',
		nextArrow: '.condition_next',
		asNavFor: '#conditions_image_carousel, #conditions_nav_carousel',
	});

	$('#conditions_nav_carousel').slick({
		slidesToShow: 3,
		slidesToScroll: 1,
		fade: false,
		vertical: true,
		arrows: false,
		dots: false,
		infinite: true,
		focusOnSelect: true,
		asNavFor: '#conditions_image_carousel, #conditions_text_carousel',
	});

	var $spot_slider = $('#spotlight_carousel');
	var $spot_progressBar = $('#spotlight .progress');
	var $spot_progressBarLabel = $( '#spotlight .slider__label' );

	$spot_slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {   
	    var calc = ( (nextSlide) / (slick.slideCount-1) ) * 100;
	    
	    $spot_progressBar
	      	.css('background-size', calc + '% 100%')
	      	.attr('aria-valuenow', calc );
	    
	    $spot_progressBarLabel.text( calc + '% completed' );
  	});

	$('#spotlight_carousel').slick({
		slidesToShow: 4,
		slidesToScroll: 1,
		fade: false,
		arrows: true,
		centerMode: true,
		prevArrow: '.spotlight_prev',
		nextArrow: '.spotlight_next',
		dots: false,
		infinite: true,
		responsive: [
		    {
		      	breakpoint: 991,
		     	settings: {
		        	slidesToShow: 2,
		        	slidesToScroll: 1,
		      	}
		    },
		    {
		      	breakpoint: 501,
		      	settings: {
		        	slidesToShow: 1,
		        	fade: true,
		        	slidesToScroll: 1,
		      	}
		    }
		]
	});

	$('#shop_footer_carousel').slick({
		slidesToShow: 4,
		slidesToScroll: 1,
		fade: false,
		arrows: false,
		prevArrow: '.sfc_prev',
		nextArrow: '.sfc_next',
		dots: false,
		infinite: true,
		responsive: [
		    {
		      	breakpoint: 991,
		     	settings: {
		     		arrows: true,
		        	slidesToShow: 2,
		        	slidesToScroll: 1,
		      	}
		    },
		    {
		      	breakpoint: 501,
		      	settings: {
		      		arrows: true,
		        	slidesToShow: 1,
		        	fade: true,
		        	slidesToScroll: 1,
		      	}
		    }
		]
	});

	$('#featured_concern_carousel').slick({
		slidesToShow: 3,
		slidesToScroll: 1,
		fade: false,
		arrows: false,
		prevArrow: '.fc_prev',
		nextArrow: '.fc_next',
		dots: false,
		infinite: true,
		responsive: [
		    {
		      	breakpoint: 991,
		     	settings: {
		     		arrows: true,
		        	slidesToShow: 2,
		        	slidesToScroll: 1,
		      	}
		    },
		    {
		      	breakpoint: 501,
		      	settings: {
		        	slidesToShow: 1,
		        	arrows: true,
		        	fade: true,
		        	slidesToScroll: 1,
		      	}
		    }
		]
	});

	$('#skin_shop_carousel').slick({
		slidesToShow: 3,
		slidesToScroll: 1,
		fade: false,
		arrows: true,
		prevArrow: '.shop_prev',
		nextArrow: '.shop_next',
		dots: false,
		infinite: true,
		responsive: [
		    {
		      	breakpoint: 991,
		     	settings: {
		        	slidesToShow: 2,
		        	slidesToScroll: 1,
		      	}
		    },
		    {
		      	breakpoint: 501,
		      	settings: {
		        	slidesToShow: 1,
		        	fade: true,
		        	slidesToScroll: 1,
		      	}
		    }
		]
	});

	$('#awards_carousel').slick({
		slidesToShow: 3,
		slidesToScroll: 1,
		fade: false,
		arrows: true,
		prevArrow: '.awards_prev',
		nextArrow: '.awards_next',
		dots: false,
		infinite: true,
		responsive: [
		    {
		      	breakpoint: 991,
		     	settings: {
		        	slidesToShow: 2,
		        	slidesToScroll: 1,
		      	}
		    },
		    {
		      	breakpoint: 501,
		      	settings: {
		        	slidesToShow: 2,
		        	slidesToScroll: 1,
		      	}
		    }
		]
	});

	$('#brands_carousel').slick({
		slidesToShow: 4,
		slidesToScroll: 1,
		fade: false,
		arrows: false,
		autoplay: true,
		autoplaySpeed: 0,
		speed: 6000,
		cssEase: 'linear',
		dots: false,
		infinite: true,
		responsive: [
		    {
		      	breakpoint: 991,
		     	settings: {
		        	slidesToShow: 2,
		        	slidesToScroll: 1,
		      	}
		    },
		    {
		      	breakpoint: 501,
		      	settings: {
		        	slidesToShow: 2,
		        	slidesToScroll: 1,
		      	}
		    }
		]
	});

	if ($('#before_afters_thumbnails').length > 0) {

		$('#before_afters_carousel').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			fade: true,
			arrows: true,
			prevArrow: '.ba_prev',
			nextArrow: '.ba_next',
			dots: false,
			infinite: true,
			asNavFor: '#before_afters_thumbnails',
		});

		$('#before_afters_thumbnails').slick({
			slidesToShow: 4,
			slidesToScroll: 1,
			fade: false,
			arrows: false,
			dots: false,
			infinite: true,
			asNavFor: '#before_afters_carousel',
			focusOnSelect: true,
		});

	} else {
		$('#before_afters_carousel').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			fade: true,
			arrows: true,
			prevArrow: '.ba_prev',
			nextArrow: '.ba_next',
			dots: false,
			infinite: true,
		});
	};

	$('#videos_carousel').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		fade: true,
		arrows: true,
		prevArrow: '.video_prev',
		nextArrow: '.video_next',
		dots: false,
		infinite: true,
	});

	$('#testimonials_videos_carousel').slick({
		slidesToShow: 3,
		slidesToScroll: 1,
		fade: false,
		arrows: true,
		prevArrow: '.vt_prev',
		nextArrow: '.vt_next',
		dots: false,
		infinite: true,
		centerMode: true,
		responsive: [
		    {
		      	breakpoint: 991,
		      	settings: {
		        	slidesToShow: 1,
		        	centerMode: false,
		        	slidesToScroll: 1,
		      	}
		    }
		]
	});

	$('#testimonials_written_carousel').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		fade: true,
		arrows: true,
		prevArrow: '.wt_prev',
		nextArrow: '.wt_next',
		dots: false,
		infinite: true,
	});

	$('#testimonials_video_tab').on('shown.bs.tab', function (e) {
		$('#testimonials_videos_carousel').slick('setPosition');
	});

	$('#testimonials_written_tab').on('shown.bs.tab', function (e) {
		$('#testimonials_written_carousel').slick('setPosition');
	});

	$('#download_text_carousel').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		fade: true,
		arrows: true,
		prevArrow: '.download_prev',
		nextArrow: '.download_next',
		dots: false,
		infinite: true,
		asNavFor: '#download_file_carousel',
	});

	$('#download_file_carousel').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		fade: true,
		arrows: false,
		dots: false,
		infinite: true,
		asNavFor: '#download_text_carousel',
	});

	$('.launch_video').click(function() {
		var src = $(this).data('src');
		var type = $(this).data('type');
		$('#video_player iframe').attr('src',src);
		$('#video_player iframe').addClass(type);
	});

	$('#video_player').on('hidden.bs.modal', function (e) {
		$('#video_player .ratio iframe').attr('src','');
		$('#video_player .ratio iframe').removeClass('.vimeo').removeClass('youtube');
	});

	$('#related_team_carousel_text').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		fade: true,
		arrows: true,
		dots: false,
		infinite: true,
		prevArrow: '.member_prev',
		nextArrow: '.member_next',
		asNavFor: '#related_team_carousel_images',
	});

	$('#related_team_carousel_images').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		fade: true,
		arrows: false,
		dots: false,
		infinite: true,
		asNavFor: '#related_team_carousel_text',
	});

	$('#locations_carousel').slick({
		slidesToShow: 4,
		slidesToScroll: 1,
		fade: false,
		arrows: true,
		dots: false,
		autoplay: true,
		infinite: true,
		prevArrow: '.location_prev',
		nextArrow: '.location_next',
		responsive: [
		    {
		      	breakpoint: 991,
		     	settings: {
		     		infinite: true,
		        	slidesToShow: 2,
		        	slidesToScroll: 1,
		      	}
		    },
		    {
		      	breakpoint: 501,
		      	settings: {
		      		autoplay: false,
		      		infinite: true,
		        	slidesToShow: 1,
		        	fade: true,
		        	slidesToScroll: 1,
		      	}
		    }
		]
	});

	$('#latest_arrivals_carousel').slick({
		slidesToShow: 4,
		slidesToScroll: 1,
		fade: false,
		arrows: true,
		dots: false,
		autoplay: false,
		infinite: true,
		prevArrow: '.latest_prev',
		nextArrow: '.latest_next',
		responsive: [
		    {
		      	breakpoint: 991,
		     	settings: {
		     		arrows: true,
		     		infinite: true,
		        	slidesToShow: 2,
		        	slidesToScroll: 1,
		      	}
		    },
		    {
		      	breakpoint: 501,
		      	settings: {
		      		arrows: true,
		        	slidesToShow: 1,
		        	fade: true,
		        	slidesToScroll: 1,
		      	}
		    }
		]
	});

	if ($('.single-team_member').length > 0) {
		$('#member_locations_carousel').slick({
			slidesToShow: 2,
			slidesToScroll: 1,
			fade: false,
			arrows: true,
			dots: false,
			infinite: true,
			prevArrow: '.location_prev',
			nextArrow: '.location_next',
			responsive: [
			    {
			      	breakpoint: 991,
			      	settings: {
			        	slidesToShow: 1,
			        	slidesToScroll: 1,
			      	}
			    }
			]
		});

		$('#rest_team_carousel').slick({
			slidesToShow: 3,
			slidesToScroll: 1,
			fade: false,
			arrows: true,
			dots: false,
			infinite: false,
			prevArrow: '.rest_prev',
			nextArrow: '.rest_next',
			responsive: [
			    {
			      	breakpoint: 991,
			     	settings: {
			     		infinite: true,
			        	slidesToShow: 2,
			        	slidesToScroll: 1,
			      	}
			    },
			    {
			      	breakpoint: 768,
			      	settings: {
			      		infinite: true,
			        	slidesToShow: 1,
			        	fade: true,
			        	slidesToScroll: 1,
			      	}
			    }
			]
		});
	};

	if ($('.page-template-book').length > 0) {
		$('#choose_xs_carousel').slick({
			slidesToShow: 1.25,
			slidesToScroll: 1,
			arrows: true,
			infinite: false,
			dots: false,
			prevArrow: '.choose_prev',
			nextArrow: '.choose_next',
		});
		// $('#input_2_9').select2({
		// 	minimumResultsForSearch: Infinity,
		// 	allowClear: false,
		// 	width: '100%',
		// 	multiple: true,
		// });

		// $('#input_2_9').on('select2:opening select2:closing', function( event ) {
		//     var $searchfield = $(this).parent().find('.select2-search__field');
		//     $searchfield.prop('disabled', true);
		// });
	}

	$('#header_filter #cat').select2({
		minimumResultsForSearch: Infinity,
		allowClear: false,
		width: '100%',
		placeholder: 'Category',
		dropdownCssClass: 'filter_dropdown',
	});

	$('#header_filter #archives-dropdown-2').select2({
		minimumResultsForSearch: Infinity,
		allowClear: false,
		width: '100%',
		placeholder: 'Archive',
		dropdownCssClass: 'filter_dropdown',
	});

	$('#related_posts_carousel').slick({
		slidesToShow: 3,
		slidesToScroll: 1,
		fade: false,
		arrows: true,
		dots: false,
		infinite: true,
		prevArrow: '.rel_prev',
		nextArrow: '.rel_next',
		responsive: [
		    {
		      	breakpoint: 991,
		     	settings: {
		     		infinite: true,
		        	slidesToShow: 2,
		        	slidesToScroll: 1,
		      	}
		    },
		    {
		      	breakpoint: 768,
		      	settings: {
		      		infinite: true,
		        	slidesToShow: 1,
		        	fade: true,
		        	slidesToScroll: 1,
		      	}
		    }
		]
	});

	if ($('.page-template-ppc_landing').length > 0) {
		$('select[name="input_11"]').select2({
			minimumResultsForSearch: Infinity,
			allowClear: false,
			width: '100%',
			placeholder: 'Location',
			dropdownCssClass: 'filter_dropdown',
		});
	}

	if ($('.page-template-team').length > 0) {

		var $grid = $('#team_gallery').imagesLoaded(function() {
			$grid.isotope({
				itemSelector: '.member',
			});
		});

		$('#filter_treatment').on( 'change', function() {
		  	// get filter value from option value
		  	var filterValue = this.value;
		  	$grid.isotope({ filter: filterValue });
		});

		$('#filter_position').on( 'change', function() {
		  	// get filter value from option value
		  	var filterValue = this.value;
		  	$grid.isotope({ filter: filterValue });
		});

		$('#filter_location').on( 'change', function() {
		  	// get filter value from option value
		  	var filterValue = this.value;
		  	$grid.isotope({ filter: filterValue });
		});

		$('#filter_xs_treatment').on( 'change', function() {
		  	// get filter value from option value
		  	var filterValue = this.value;
		  	$grid.isotope({ filter: filterValue });
		});

		$('#filter_xs_position').on( 'change', function() {
		  	// get filter value from option value
		  	var filterValue = this.value;
		  	$grid.isotope({ filter: filterValue });
		});

		$('#filter_xs_location').on( 'change', function() {
		  	// get filter value from option value
		  	var filterValue = this.value;
		  	$grid.isotope({ filter: filterValue });
		});

		$('#filter_position').select2({
			minimumResultsForSearch: Infinity,
			allowClear: false,
			width: '100%',
			placeholder: 'Position',
			dropdownCssClass: 'filter_dropdown',
			templateSelection: function (data, container) {
			    // Add custom attributes to the <option> tag for the selected option
			    $(data.element).attr('data-value', data.customValue);
			    return data.text;
		  	}
		});

		$('#filter_treatment').select2({
			minimumResultsForSearch: Infinity,
			allowClear: false,
			width: '100%',
			placeholder: 'Treatment',
			dropdownCssClass: 'filter_dropdown',
			templateSelection: function (data, container) {
			    // Add custom attributes to the <option> tag for the selected option
			    $(data.element).attr('data-value', data.customValue);
			    return data.text;
		  	}
		});

		$('#filter_location').select2({
			minimumResultsForSearch: Infinity,
			allowClear: false,
			width: '100%',
			placeholder: 'Location',
			dropdownCssClass: 'filter_dropdown',
			templateSelection: function (data, container) {
			    // Add custom attributes to the <option> tag for the selected option
			    $(data.element).attr('data-value', data.customValue);
			    console.log(data.text);
			    return data.text;
		  	}
		});

		$('#filter_xs_position').select2({
			minimumResultsForSearch: Infinity,
			allowClear: false,
			width: '100%',
			placeholder: 'Position',
			dropdownCssClass: 'filter_dropdown',
			templateSelection: function (data, container) {
			    // Add custom attributes to the <option> tag for the selected option
			    $(data.element).attr('data-value', data.customValue);
			    return data.text;
		  	}
		});

		$('#filter_xs_treatment').select2({
			minimumResultsForSearch: Infinity,
			allowClear: false,
			width: '100%',
			placeholder: 'Treatment',
			dropdownCssClass: 'filter_dropdown',
			templateSelection: function (data, container) {
			    // Add custom attributes to the <option> tag for the selected option
			    $(data.element).attr('data-value', data.customValue);
			    return data.text;
		  	}
		});

		$('#filter_xs_location').select2({
			minimumResultsForSearch: Infinity,
			allowClear: false,
			width: '100%',
			placeholder: 'Location',
			dropdownCssClass: 'filter_dropdown',
			templateSelection: function (data, container) {
			    // Add custom attributes to the <option> tag for the selected option
			    $(data.element).attr('data-value', data.customValue);
			    return data.text;
		  	}
		});


		$('#filter_position').on('select2:select', function (e) {
			var target = $('#filter_position').find(':selected').data('value');
			$grid.isotope({ filter: target });
		});

		$('#filter_treatment').on('select2:select', function (e) {
			var target = $('#filter_treatment').find(':selected').data('value');
			$grid.isotope({ filter: target });
		});

		$('#filter_location').on('select2:select', function (e) {
			var target = $('#filter_location').find(':selected').data('value');
			$grid.isotope({ filter: target });
		});

		$('#filter_xs_position').on('select2:select', function (e) {
			var target = $('#filter_xs_position').find(':selected').data('value');
			$grid.isotope({ filter: target });
		});

		$('#filter_xs_treatment').on('select2:select', function (e) {
			var target = $('#filter_xs_treatment').find(':selected').data('value');
			$grid.isotope({ filter: target });
		});

		$('#filter_xs_location').on('select2:select', function (e) {
			var target = $('#filter_xs_location').find(':selected').data('value');
			$grid.isotope({ filter: target });
		});
			
		$('#other_team_carousel').slick({
			slidesToShow: 3.75,
			slidesToScroll: 1,
			fade: false,
			arrows: true,
			dots: false,
			infinite: false,
			prevArrow: '.other_prev',
			nextArrow: '.other_next',
			responsive: [
			    {
			      	breakpoint: 991,
			     	settings: {
			     		infinite: true,
			        	slidesToShow: 2,
			        	slidesToScroll: 1,
			      	}
			    },
			    {
			      	breakpoint: 768,
			      	settings: {
			      		infinite: true,
			        	slidesToShow: 1,
			        	fade: true,
			        	slidesToScroll: 1,
			      	}
			    }
			]
		});
	};

	$('#pricing_filter a').click(function() {
		if ($(window).width() < 991) {
			$('#pricing_filter').removeClass('show');
			$('a[href="#pricing_filter"]').attr('aria-expanded',false);
		}
	});


	if ($(window).width() > 991) {
	    $('.ti-widget-container').removeClass('ti-col-4');
	    $('.ti-widget-container').removeClass('ti-col-5');
	    $('.ti-widget-container').addClass('ti-col-3');
  	}

  	setInterval(() => {
	    if ($(window).width() > 991) {
	      	$('.ti-widget-container').removeClass('ti-col-4');
	      	$('.ti-widget-container').removeClass('ti-col-5');
	      	$('.ti-widget-container').addClass('ti-col-3');
    	}
	}, 400);

	// woocommerce

	//enables Font Awesome pseudo elements
    window.FontAwesomeConfig = {
        searchPseudoElements: true
    }

     //Products filter for Isotope
    function filter() {

        //  $('html, body').animate({scrollTop: '0px'});

        $('.category-grid').addClass('loading');


        setTimeout(function () {
            $('.loading-wrapper').fadeIn(250);
        }, 250);

        setTimeout(function () {
            $('.loading-wrapper').fadeOut(250);
        }, 2750);

        setTimeout(function () {

            $('.category-grid').removeClass('loading');

            $('.category-grid').isotope({

                filter: function () {

                    // Brand Filter

                    var brand = $(this).data('brand');
                    var brand_filter = $('.brand-filter').val();

                    if (brand_filter == 'all') {

                        var brand_status = true;

                    } else {

                        if ($(this).length > 0) {
                            var brand_filter = brand_filter.split(',');

                            if ($.inArray(brand, brand_filter) !== -1) {
                                var brand_status = true;
                            } else {
                                var brand_status = false;
                            }
                        }

                    }

                    // Condition Filter

                    //var conditions = $(this).data('conditions');
                    var condition_filter = $('.condition-filter').val();

                    if (condition_filter == 'all') {

                        var condition_status = true;

                    } else {

                        if ($(this).length > 0) {
                            var conditions = $(this).data('conditions').split(',');

                            if ($.inArray(condition_filter, conditions) !== -1) {
                                var condition_status = true;
                            } else {
                                var condition_status = false;
                            }
                        }

                    }


                    //Category Filter

                    var category_filter = $('.category-filter').val();

                    if (category_filter == 'all') {

                        var category_status = true;

                    } else {

                        if ($(this).length > 0) {
                            var categories = $(this).data('categories').split(',');

                            if ($.inArray(category_filter, categories) !== -1) {
                                var category_status = true;
                            } else {
                                var category_status = false;
                            }
                        }

                    }

                    // Price Filter 

                    var price = parseFloat($(this).data('price'));
                    var price_filter_lower = parseFloat($('.price-filter-lower').val());
                    var price_filter_upper = parseFloat($('.price-filter-upper').val());

                    if ((price_filter_lower <= price) && (price <= price_filter_upper)) {
                        var price_status = true;
                    } else {
                        var price_status = false;
                    }

                    // Overall Filter Status

                    if (brand_status == true && condition_status && category_status == true && price_status == true) {
                        return true;
                    } else {
                        return false;
                    }

                }



            });

            if ($('.category-grid').data('isotope').filteredItems.length == 0) {
                $('.category-grid').css('height', $('.category-grid .no-items-found').outerHeight(true));
                $('.category-grid .no-items-found').addClass('active');

            } else {
                $('.category-grid .no-items-found').removeClass('active');
            }

        }, 3000);

        $.fn.matchHeight._update();

    }

    if ($('body').hasClass('single-product') ) {
         //Single products accordion
            // $('.accordion_prods .toggle').click(function(e) {
            //     e.preventDefault();
            //     var $this = $(this);
            //     if ($this.parents('.accordion_prods').find('.inner').hasClass('show')) {
            //         $this.parents('.accordion_prods').find('.inner').removeClass('show');
            //         $this.parents('.accordion_prods').find('.inner').slideUp(350);
            //         $this.parents('.accordion_prods').removeClass('open');
            //         $this.find('span').html('<i class="fal fa-chevron-down"></i>');
                    
            //     } else {
            //         $this.parents('.accordion_prods').find('.inner').addClass('show');
            //         $this.parents('.accordion_prods').find('.inner').slideDown(350);
            //         $this.parents('.accordion_prods').addClass('open');
            //         $this.find('span').html('<i class="fal fa-chevron-up"></i>');
            //     }
            // });

              $('.rel-prods-slider').slick({
                    dots: false,
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: true,
                    arrows: false,
                    responsive: [{
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                        }
                    }]
                });

            $('.rel-prods-slider-mob').slick({
                dots: false,
                slidesToShow: 4,
                slidesToScroll: 1,
                infinite: false,
                speed: 300,
                slidesToShow: 2,
                slidesToScroll: 2,
                arrows: false,
            });

            $('#product-gallery-main').slick({
                autoplay: false,
                dots: false,
                infinite: false,
                speed: 500,
                pauseOnHover: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                fade: false,
                arrows: false,
                cssEase: 'linear',
                adaptiveHeight: false,
                asNavFor: '#product-gallery-thumbs',
                responsive: [{
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: false,
                    }
                }]
            });


            $('#product-gallery-main-mob').slick({
                autoplay: false,
                dots: true,
                infinite: false,
                speed: 500,
                pauseOnHover: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                fade: false,
            });


            $('#product-gallery-thumbs').slick({
                autoplay: false,
                dots: false,
                infinite: false,
                speed: 500,
                pauseOnHover: false,
                slidesToShow: 4,
                slidesToScroll: 1,
                arrows: false,
                cssEase: 'linear',
                adaptiveHeight: false,
                asNavFor: '#product-gallery-main',
                focusOnSelect: true,
            });

       }


    // CATEGORY SCRIPTS

    if ($('body').hasClass('tax-product_cat') || $('body').hasClass('post-type-archive-product') || $('body').hasClass('search-results') || $('body').hasClass('woocommerce-page') || !$('body').hasClass('page-template-basket') || !$('body').hasClass('woocommerce-checkout')) {

        // Set Brand

        $('.brand-filter-list .micro-filter').on('click', function () {

            brands = [];
            $(this).toggleClass('active');

            $('.brand-filter-list .micro-filter.active').each(function () {
                brands.push($(this).data('brand'));
            });

            if (brands.length < 1) {
                var brands = 'all';
            } else {
                var brands = brands.toString();
            }

            $('.brand-filter').val(brands);

            $.fn.matchHeight._update();

        });


        // Set Conditions

        $('.concern-filter-list .micro-filter').on('click', function () {

            // Make All Others Inactive and Clicked one Active/Inactive

            $('.concern-filter-list .micro-filter').not(this).removeClass('active');
            $(this).toggleClass('active');

            if ($(this).data('concern') == $('.condition-filter').val()) {
                var condition = 'all';
            } else {
                var condition = $(this).data('concern');
            }

            $('.condition-filter').val(condition);

            $.fn.matchHeight._update();

        });


        // Set Categories

        $('.category-filter-list .micro-filter').on('click', function () {

            // Make All Others Inactive and Clicked one Active/Inactive

            $('.category-filter-list .micro-filter').not(this).removeClass('active');
            $(this).toggleClass('active');

            if ($(this).data('category') == $('.category-filter').val()) {
                var category = 'all';
            } else {
                var category = $(this).data('category');
            }

            $('.category-filter').val(category);

            $.fn.matchHeight._update();

            //console.log( $('.category-filter').val() );
            //console.log( $(this).data('category') );

        });



        // Set Minimum Rating

        $('.filter .rating svg').on('click', function () {
            console.log('clicked');

            var minimum_rating = $(this).data('minimum-rating');

            $('.minimum-rating .clear').addClass('active');

            if (minimum_rating == '1') {

                $('.star-1').addClass('active');
                $('.star-2, .star-3, .star-4, .star-5').removeClass('active');

            } else if (minimum_rating == '2') {

                $('.star-1, .star-2').addClass('active');
                $('.star-3, .star-4, .star-5').removeClass('active');

            } else if (minimum_rating == '3') {

                $('.star-1, .star-2, .star-3').addClass('active');
                $('.star-4, .star-5').removeClass('active');

            } else if (minimum_rating == '4') {

                $('.star-1, .star-2, .star-3, .star-4').addClass('active');
                $('.star-5').removeClass('active');

            } else if (minimum_rating == '5') {

                $('.star-1, .star-2, .star-3, .star-4, .star-5').addClass('active');

            }

            $('.minimum-rating-filter').val(minimum_rating);

            $.fn.matchHeight._update();

        });

        // Clear Minimum Rating

        $('.minimum-rating .clear').on('click', function () {
            $('.star-1, .star-2, .star-3, .star-4, .star-5').removeClass('active');
            $('.minimum-rating-filter').val(0);
            $(this).removeClass('active');
        });

        // Set Lower Price

        // $('.filter .price-lower').on('change', function () {
        //     var price_lower = $(this).val();
        //     $('.price-filter-lower').val(price_lower)
        // });

        // Set Upper Price

        $('.form-range').on('change', function () {
        	var min = 0;
            var price_upper = $(this).val();
            $('.price_upper').text(price_upper);
            $('.price-filter-lower').val(min);
            $('.price-filter-upper').val(price_upper);
        });

        // Isotope Filter and Grid


        $('.brand-filter-list .micro-filter, .concern-filter-list .micro-filter, .category-filter-list .micro-filter').on('click', function () {
            filter();
        });

        $('.form-range').on('change', function () {
            filter();
        });

        //hiding unused data brand
        //$('*[data-data="obagi-new-derm"]').hide();

        $('.quantity select').select2({
        	width: '100%',
        	minimumResultsForSearch: Infinity,
			allowClear: false,
			dropdownCssClass: 'filter_dropdown',
        });

    }

     // WRITE A REVIEW SCRIPTS

    if ($('body').hasClass('page-template-write_review')) {

        if ($('.gform_confirmation_message').length < 1) {

            $('.gform_fields').addClass('')
            $('.gfield, .gform_footer').addClass('row gx_0 pt-10 pt-lg-20 pb-10 pb-lg-15');
            $('.gfield .gfield_label').addClass('col-lg-4 fs-18 lh-100');
            $('.gfield .ginput_container').addClass('col-lg-8');
            $('.gfield input, .gfield textarea').addClass('bf2-400 fs-12 fs-lg-14');
            $('.gform_button').wrap('<div class="col-lg-4 offset-lg-4"></div>');

            $('.rating').prependTo('.review_rating .ginput_container');
            $('.review_rating input').addClass('d-none');

        } else {

            $('.rating').remove();
            $('.gform_confirmation_message').addClass('w-100 w-lg-50 mx-auto text-center');

        }

        $(document).on('click', '.review_rating .rating svg', function () {

            var rating = $(this).data('rating');

            if (rating == '1') {

                $('.star-1').addClass('active');
                $('.star-2, .star-3, .star-4, .star-5').removeClass('active');

            } else if (rating == '2') {

                $('.star-1, .star-2').addClass('active');
                $('.star-3, .star-4, .star-5').removeClass('active');

            } else if (rating == '3') {

                $('.star-1, .star-2, .star-3').addClass('active');
                $('.star-4, .star-5').removeClass('active');

            } else if (rating == '4') {

                $('.star-1, .star-2, .star-3, .star-4').addClass('active');
                $('.star-5').removeClass('active');

            } else if (rating == '5') {

                $('.star-1, .star-2, .star-3, .star-4, .star-5').addClass('active');

            }

            $('.review_rating input').val(rating);

        });

    }

    // Checkout Functions

    $('button[name="update_cart"]').click(function() {
    	$(document.body).trigger('wc_fragment_refresh');
    });

    // Validate Checkout Steps

    function validateCheckout(data, step, nextStepIndex) {
        $.ajax({
            url: '/wp-content/themes/blowmedia/scripts/validate' + step + 'Checkout.php',
            type: 'POST',
            data: data,
            success: function (response) {
                var response = response.trim();
                if (response) {
                 $('.' + step.toLowerCase() + '-step .validation-button-wrapper').addClass('open');
                 $('.' + step.toLowerCase() + '-step .validation-wrapper').addClass('open').find('ul').html('<p class="fs_22 text-center fsx_18 text-peach fwb mb_20 mbx_20">Please correct the following before continuing:</p>' + response);
                } else {
                $('.main-checkout').fadeOut(500);
                setTimeout(function () {
                    $('.' + step.toLowerCase() + '-step .validation-wrapper ul').addClass('closed');
                    $('.checkout-step').hide();
                    $('.checkout-step').eq(nextStepIndex).show();
                    $('.steps-detaiils a').removeClass('current');
                    $('.steps-detaiils a').eq(nextStepIndex - 1).addClass('done');
                    $('.steps-detaiils a').eq(nextStepIndex).addClass('current');
                    $('.main-checkout').fadeIn(500);
                    $('html, body').animate({ scrollTop: 0 }, 500);
                    if ($('.steps-detaiils a.payment-review-link').hasClass('current')) {
                        $('.order-review-wrapper .discount-code').addClass('active');
                    }

                    }, 500);
                }
            }
        });
    }


    //add custom checkmark shipping radio button
    $('<span class="checkmark"></span>').insertAfter('.woocommerce-checkout ul#shipping_method li input');


    // Sort Formatting on Payment Step of Checkout

    function fixPaymentStep() {

        if ($('.fix-payment-step').val() == 0) {

            // Set Initial State of Payment Method

            setTimeout(function () {

                $('#payment_method_stripe').prop('checked', true);
                $('#payment_method_ppec_paypal').prop('checked', false);
                $('li.payment_method_stripe > label > .circle').addClass('closed');
                //to activate in case User has Paypal payment as well
                $('li.payment_method_ppec_paypal > .payment_box').addClass('filled');

            }, 3);


            // Set Alignment of Expiry Date and CVC 
            $('<div class="row expiry-cvc-wrapper"></div>').insertBefore('.payment_method_stripe .form-row-first');
            $('.payment_method_stripe .form-row-first, .payment_method_stripe .form-row-last').appendTo('.expiry-cvc-wrapper');

            // Add Circle To Saved Payment Info

            // $('.woocommerce-SavedPaymentMethods-saveNew label').prepend('<div class="circle"></div>');

            // Alter Submit Button Details

            var label = 'Place Order';

            $('.order-btn').val(label).attr('data-value', label).html('<div class="nohover animated"><span>' + label + '</span></div><div class="hovered animated"><span>' + label + '</span></div>');

            // Set Initial State of Shipping Address Checkbox

            $('#ship-to-different-address-checkbox').prop('checked', true);

            // Set State of Payment Fix

            $('.fix-payment-step').val(1);

        }

    }

    // Copy Billing Address to Shipping Address

    function copyBillingAddress() {
        $('#shipping_first_name').val($('#billing_first_name').val());
        $('#shipping_last_name').val($('#billing_last_name').val());
        $('#shipping_company').val($('#billing_company').val());
        $('#shipping_address_1').val($('#billing_address_1').val());
        $('#shipping_address_2').val($('#billing_address_2').val());
        $('#shipping_city').val($('#billing_city').val());
        $('#shipping_state').val($('#billing_state').val());
        $('#shipping_postcode').val($('#billing_postcode').val());
    }


    // Refresh Order Details After Change

    function refreshOrderDetails(data) {
        $.ajax({
            url: '/wp-content/themes/blowmedia/scripts/getOrderDetails.php',
            type: 'POST',
            data: data,
            success: function (response) {
                $('.order-review-wrapper').fadeOut(500);
                setTimeout(function () {
                    $('.order-review-wrapper').html(response);
                    $('.cart_items').css('height', $('.cart_items').outerHeight() + 1);
                    $('.cart_items').addClass('closed');
                    $('.order-review-wrapper').fadeIn(500);
                }, 500);
            }
        });
    }

    // Apply Discount Code 

    function applyDiscount(data) {
        $.ajax({
            url: '/wp-content/themes/blowmedia/scripts/applyDiscount.php',
            type: 'POST',
            data: data,
            success: function (response) {
                $('.discount-validation-wrapper').html(response).removeClass('loading');
                if (response.indexOf('Coupon code applied successfully.') >= 0) {
                    $('.discount-validation-wrapper').html(response).addClass('loading');
                    $('.discount-validation-wrapper').html('<div class="woocommerce-message" role="alert"><p class="fs_22 fwb">Discount applied on your order.</p></div>');
                    refreshOrderDetails(data);
                }
            }
        });
    }

    // Get Available Delivery Methods

    function getShippingGoToPayment(data) {
        $.ajax({
            url: '/wp-content/themes/blowmedia/scripts/getShippingMethod.php',
            type: 'POST',
            data: data,
            success: function (response) {
                var response = response.trim();
                var response = JSON.parse(response);
                var data2 = {
                    'shipping_id': response['id'],
                    'shipping_cost': response['cost'],
                    'shipping_vat': response['vat']
                };
                $(".order-details #overlay").fadeOut(300);　
                $('.shipping_method').attr('value', response['id']).attr('id', 'shipping_method_0_' + response['id'].replace(':', '').replace('-', '_'));
                refreshOrderDetails(data2);
                validateCheckout(data, 'Shipping', 2);
                 $('.shipping-total').html('&pound;' + (response['cost'] / 100).toFixed(2));
                
                fixPaymentStep();
            }
        });
    }


    function get_ShippingDetails() {
        var checkbox = $('.ship-address-toggle').find('input');
        if (!$(checkbox).is(':checked')) {
            var shipping_name = $('#billing_first_name').val();
            var shipping_last_name = $('#billing_last_name').val();
            var shipping_address_1 = $('#billing_address_1').val();
            var shipping_address_2 = $('#billing_address_2').val();
            var shipping_city = $('#billing_city').val();
            var shipping_state = $('#billing_state').val();
            var shipping_postcode = $('#billing_postcode').val();
        } else {
            var shipping_name = $('#shipping_first_name').val();
            var shipping_last_name = $('#shipping_last_name').val();
            var shipping_address_1 = $('#shipping_address_1').val();
            var shipping_address_2 = $('#shipping_address_2').val();
            var shipping_city = $('#shipping_city').val();
            var shipping_state = $('#shipping_state').val();
            var shipping_postcode = $('#shipping_postcode').val();
        }
        var shipping_phone = $('#billing_phone').val();
        var shipping_email = $('#billing_email').val();

        var review_shipping_wrapper = $('.checkout-step.review-step .review-wrapper .shipping_details');

        review_shipping_wrapper.html("<p class='fs16'>" + shipping_name + " " + shipping_last_name + "</p><p class='fs16'>" + shipping_address_1 + "</p><p class='fs16'>" + shipping_address_2 + "</p><p class='fs16'>" + shipping_city + "</p>" +
            " <p class='fs16'>" + shipping_state + "</p> " + " <p class='fs16'>" + shipping_postcode + "</p> " + " <p class='fs16'>" + shipping_email + "</p> " + " <p class='fs16'>" + shipping_phone + "</p> ");

    }

    function get_BillingDetails() {
        var billing_name = $('#billing_first_name').val();
        var billing_last_name = $('#billing_last_name').val();
        var billing_address_1 = $('#billing_address_1').val();
        var billing_address_2 = $('#billing_address_2').val();
        var billing_city = $('#billing_city').val();
        var billing_state = $('#billing_state').val();
        var billing_postcode = $('#billing_postcode').val();
        var billing_phone = $('#billing_phone').val();
        var billing_email = $('#billing_email').val();

        var review_billing_wrapper = $('.checkout-step.review-step .review-wrapper .billing_details');

        review_billing_wrapper.html("<p class='fs16'>" + billing_name + " " + billing_last_name + " </p><p class='fs16'>" + billing_address_1 + "</p><p class='fs16'>" + billing_address_2 + "</p><p class='fs16'>" + billing_city + "</p>" +
            " <p class='fs16'>" + billing_state + "</p> " + " <p class='fs16'>" + billing_postcode + "</p> " + " <p class='fs16'>" + billing_email + "</p> " + " <p class='fs16'>" + billing_phone + "</p> ");

    }

    // Proceed to Payment

    function proceedPayment(data) {
        validateCheckout(data, 'Shipping', 2);
        fixPaymentStep();
    }

     // Checkout Actions

    if ($('body').hasClass('woocommerce-checkout')) {

    $('.woocommerce-shipping-methods li').on('click', function () {
        $(".order-details #overlay").fadeIn(300);　
        var that = this;
        // $('.woocommerce-shipping-methods li').removeClass('active');
        $('body').trigger('update_checkout', { update_shipping_method: true });

        setTimeout(function () {
            if( $('.woocommerce-shipping-methods li').hasClass('active') ){
                   $('.woocommerce-shipping-methods li').removeClass('active');
            }
            $(that).addClass('active').find('input').prop('checked', true);
        }, 1);

       getShippingGoToPayment();

    });

    $('#billing_country').change(function(){
          $('body').trigger('update_checkout', { update_shipping_method: true });

        setTimeout(function () {
            getShippingGoToPayment();
        }, 1);
    });

    $('#woocommerce-shipping-methods .shipping_method').prop('checked', true);
    $('#woocommerce-shipping-methods li').addClass('active');

        //$(document).on('click', '.show-hide-order-details', function () {
            //$('.order-details .cart_items').toggleClass('closed');
            //$(this).find('.show').toggleClass('d-none');
            //$(this).find('.hide').toggleClass('d-none');
       // });

        // Set Order Details Height

       // $('.order-details .cart_items').css('height', $('.order-details .cart_items').outerHeight() + 1);

        //setTimeout(function () {
           // $('.order-details .cart_items').addClass('closed')
       // }, 1);

        // Add Class To Billing State and Shipping State

        $('#billing_state_field input').addClass('form-control');
        $('#shipping_state_field input').addClass('form-control');



        // Toggle Class on Billing/Shipping Address Radio & Show/Hide Shipping Details

        $(document).on('click', '.ship-address-toggle', function () {
            var checkbox = $('.ship-address-toggle').find('input');
            $(this).find('.circle').toggleClass('filled');
            $('.shipping_address').toggleClass('closed');
            checkbox.prop('checked', !checkbox.prop('checked'));
            copyBillingAddress();
        });


        setTimeout(function () {

            // Set Initial State of Shipping Address Checkbox           

            $('.checkout-step').hide();
            $('.checkout-step').eq(0).show();

        }, 1);


        // Jump to Checkout Step

        // Continue Buttons 


        $('.billing-btn').on('click', function () {

            $('[name="shipping_flag"]').val(0);
            $('.billing-link').find('span').hide();
            $('.shipping-link').find('span').show();


            // Set Billing Data

            var data = {
                'forename': $('[name="billing_first_name"]').val(),
                'lastname': $('[name="billing_last_name"]').val(),
                'address1': $('[name="billing_address_1"]').val(),
                'address2': $('[name="billing_address_2"]').val(),
                'city': $('[name="billing_city"]').val(),
                'county': $('[name="billing_state"]').val(),
                'postcode': $('[name="billing_postcode"]').val(),
                'phone': $('[name="billing_phone"]').val(),
                'email': $('[name="billing_email"]').val()
            };

            // Validate Billing Checkout

            validateCheckout(data, 'Billing', 1);


            // Add Address to Review Section

            var billing_address = data.forename + '<br />' + data.lastname + '<br />' + data.company + '<br />' + data.address1 + '<br />' + data.address2 + '<br />' + data.city + '<br />' + data.county + '<br />' + data.postcode + '<br />' + data.phone + '<br />' + data.email;
            var billing_address = billing_address.replace('undefined', '').replace('<br /><br />', '<br />').replace('<br /><br />', '<br />').replace('<br /><br />', '<br />');

            $('address.billing').html(billing_address);

        });

        //Shipping 


        $('body').on('click', '.shipping-btn', function () {
            $(".woocommerce-shipping-methods li input[type='checkbox']").prop('checked', true);
         	$(".woocommerce-shipping-methods li ").addClass('active');
            
        });

        $('.shipping-btn').on('click', function () {

            $('.checkout-step').hide();
            $('.steps-details li a').removeClass('current');
            $('.delivery-method-link').addClass('current');
            $('.shipping-link').removeClass('current');
            $('.delivery-methods-step').show();

            var data = {
                'ship_different': $('[name="ship_to_different_address"]').is(":checked"),
                'forename': $('[name="shipping_first_name"]').val(),
                'lastname': $('[name="shipping_last_name"]').val(),
                'address1': $('[name="shipping_address_1"]').val(),
                'address2': $('[name="shipping_address_2"]').val(),
                'city': $('[name="shipping_city"]').val(),
                'county': $('[name="shipping_state"]').val(),
                'postcode': $('[name="shipping_postcode"]').val()
            };

            // Add Address to Review Section

            if (data.ship_different === true) {

                var shipping_address = data.forename + '<br />' + data.lastname + '<br />' + data.company + '<br />' + data.address1 + '<br />' + data.address2 + '<br />' + data.city + '<br />' + data.county + '<br />' + data.postcode;
                var shipping_address = shipping_address.replace('undefined', '').replace('<br /><br />', '<br />').replace('<br /><br />', '<br />').replace('<br /><br />', '<br />');

            } else {

                var shipping_address = 'Same as billing address';

            }


            $('address.shipping').html(shipping_address);

            var checkbox = $('.ship-address-toggle').find('input');
            if (!$(checkbox).is(':checked')) {
                copyBillingAddress();
            }

        });

        //Delivery methods

        $('.delivery-method-btn').on('click', function () {
            $('.checkout-step').hide();
            $('.discount-code').addClass('active');
            $('.steps-details li a, .delivery-method-link').removeClass('current');
            $('.review-order-link').addClass('current');
            $('.review-step').show();
            $('html, body').animate({ scrollTop: 0 }, 500);
            get_ShippingDetails();
            get_BillingDetails();
            fixPaymentStep();
        });



        // Checkout Breadcrumb

        $('.steps-detaiils a').each(function (index, value) {
            $(this).on('click', function () {
                if ($(this).hasClass('done')) {
                    $('.main-checkout').fadeOut(500);
                    var that = this;
                    setTimeout(function () {
                        $('.steps-detaiils a').removeClass('current');
                        $(that).addClass('current');
                        $('.checkout-step').hide();
                        $('.checkout-step').eq(index).show();
                        $('.main-checkout').fadeIn(500);
                        console.log(index);
                    }, 500);
                }
            });
        });


        $('.review-delivery-method a').on('click', function () {
            $('.main-checkout').fadeOut(500);
            setTimeout(function () {
                $('.steps-detaiils a').removeClass('current');
                $('.steps-detaiils a').eq(2).addClass('current');
                $('.checkout-step').hide();
                $('.checkout-step').eq(2).show();
                $('.main-checkout').fadeIn(500);
                $('html, body').animate({ scrollTop: 0 }, 500);
            }, 500);
        });

        $('.review-order-btn').on('click', function () {
            $('.checkout-step').hide();
            $('.steps-details li a').removeClass('current');
            $('.paymnent-order-link').addClass('current');
            $('.payment-review-step').show();
            $('.review-order-link').removeClass('current');
            $('html, body').animate({ scrollTop: 0 }, 500);
        });

        $('.back-to-billing').on('click', function () {
            $('.checkout-step').hide();
            $('.steps-details li a').removeClass('current');
            $('.billing-link').addClass('current');
            $('.billing-step').show();
            $('.review-order-link').removeClass('current');
            $('html, body').animate({ scrollTop: 0 }, 500);
        });

        $('.back-to-shipping').on('click', function () {
            $('.checkout-step').hide();
            $('.steps-details li a').removeClass('current');
            $('.shipping-link').addClass('current');
            $('.shipping-step').show();
            $('.review-order-link').removeClass('current');
            $('html, body').animate({ scrollTop: 0 }, 500);
            var checkbox = $('.ship-address-toggle').find('input');
            if ($(checkbox).is(':checked')) {
                $(checkbox).prop('checked', true);
            }
        });


        //Remove discount code
        $(document).on('click', '.apply-discount-code', function () {
            var data = { 'discount_code': $('[name="discount_code"]').val() };
            $('.discount-validation-wrapper').addClass('loading');
            applyDiscount(data);
        });

        //Remove discount code
        $(document).on('click', '.remove-discount', function () {
            removeDiscount();
        });


        // When Stripe Errors Appear

        var stripe_error_flag = 0;

        window.setInterval(function () {
            var exist = $('.wc-stripe-error').length;
            if (exist && stripe_error_flag == 0) {
                var stripe_errors = $('.wc-stripe-error').html();
                $('.payment-review-step .validation-wrapper ul').html(stripe_errors);
                $('.payment-review-step .validation-wrapper').addClass('open');
                $('.payment-review-step .validation-button-wrapper').addClass('open');
                $('html, body').animate({ scrollTop: $('.woocommerce-privacy-policy-text').position().top }, 500);
                stripe_error_flag = 1;
            }
        }, 100);

    }//Checkout actions

      $('.woocommerce-product-attributes-item__value a').on("click", function (e) {
        e.preventDefault();
    });

      $('.type-product .woocommerce-product-attributes .woocommerce-product-attributes-item__label').text('Size:');

    //Update the quantity on click
    
    // On Page Load
    $(window).on('load', function () {

        $('.category-grid').isotope({
            itemSelector: '.category-product',
            layoutMode: 'fitRows',
            percentPosition: true,
        });

        $.fn.matchHeight._update();
       

    });

    $('.header-slider').slick({
	    dots: false,
	    autoplay: true,
	    autoplaySpeed: 4000,
	    fade: true,
	    speed: 800,
	    adaptiveHeight: true,
	    prevArrow: $('.header-arrow-left'),
	    nextArrow: $('.header-arrow-right'),
	    arrows: true
  	});

  	function updateNavbarOnScroll() {
	    const scrollTop = $(window).scrollTop();
	    const isBannerVisible = $('.header-popup').is(':visible');
	    if (scrollTop > 50) {
	      	$('.navbar').addClass('scrolled');
	      	if (isBannerVisible) {
	        	$('.navbar').addClass('with-banner');
	      	} else {
	        	$('.navbar').removeClass('with-banner');
	      	}
	    } else {
	      	$('.navbar').removeClass('scrolled with-banner');
	    }
	}

	$('.close-header-popup').on('click', function () {
	    $('.header-popup').addClass('hidden');
	    updateNavbarOnScroll(); // Trigger update after hiding banner
	});

	$(window).on('scroll', function () {
	    updateNavbarOnScroll();
	});
	$(window).on('load', function () {
	    updateNavbarOnScroll();
	});
});
